/**
 * @generated SignedSource<<7baa00ec484b4eeba771b677cf274e42>>
 * @relayHash 0cde68ecd5e2a6f9b909cedf029b2298
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0cde68ecd5e2a6f9b909cedf029b2298

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreventionProgramDismissReason = "APPOINTMENT_ALREADY_BOOKED_THROUGH_MEDGATE" | "PATIENT_HAS_NO_INCREASED_RISK" | "PATIENT_IS_ALREADY_IN_PROGRAM" | "PATIENT_IS_NOT_INTERESTED" | "PATIENT_SELF_ORGANIZES";
export type PreventionProgramEngagementStatus = "BOOKED" | "DISMISSED";
export type De_savePreventionProgramEngagementsInput = {
  engagements: ReadonlyArray<De_preventionProgramEngagementInput>;
  patientId: string;
};
export type De_preventionProgramEngagementInput = {
  dismissReason?: PreventionProgramDismissReason | null;
  preventionProgramKey: string;
  status: PreventionProgramEngagementStatus;
};
export type deSavePreventionProgramEngagementsMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: De_savePreventionProgramEngagementsInput;
};
export type deSavePreventionProgramEngagementsMutation$data = {
  readonly savePreventionProgramEngagements: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly patientPreventionProgramOutput: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PatientPreventionProgramOutputFragment">;
    }> | null;
  };
};
export type deSavePreventionProgramEngagementsMutation = {
  response: deSavePreventionProgramEngagementsMutation$data;
  variables: deSavePreventionProgramEngagementsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "en",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "de",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fr",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "it",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deSavePreventionProgramEngagementsMutation",
    "selections": [
      {
        "alias": "savePreventionProgramEngagements",
        "args": (v2/*:: as any*/),
        "concreteType": "De_savePreventionProgramEngagementsPayload",
        "kind": "LinkedField",
        "name": "de_savePreventionProgramEngagements",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientPreventionProgramOutput",
            "kind": "LinkedField",
            "name": "patientPreventionProgramOutput",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientPreventionProgramOutputFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deSavePreventionProgramEngagementsMutation",
    "selections": [
      {
        "alias": "savePreventionProgramEngagements",
        "args": (v2/*:: as any*/),
        "concreteType": "De_savePreventionProgramEngagementsPayload",
        "kind": "LinkedField",
        "name": "de_savePreventionProgramEngagements",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientPreventionProgramOutput",
            "kind": "LinkedField",
            "name": "patientPreventionProgramOutput",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalizedName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LocalizedInstruction",
                "kind": "LinkedField",
                "name": "localizedInstruction",
                "plural": false,
                "selections": [
                  (v5/*:: as any*/),
                  (v4/*:: as any*/),
                  (v6/*:: as any*/),
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dismissReason",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastUpdated",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "patientPreventionProgramOutput",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "addConnections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PreventionProgramsEdge"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0cde68ecd5e2a6f9b909cedf029b2298",
    "metadata": {},
    "name": "deSavePreventionProgramEngagementsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c3e8cc8f9986011e412c0cbe1bc8948c";

export default node;
